import React from 'react';
import Cookies from 'js-cookie';
import DownloadButtons from '../taiapp.jsx';
import Language_i18 from '../../js/useNationalLanguage.jsx';
import { useSelector } from "react-redux";
import { isLocalHost } from '../../shared/host_utils.js';

const SystemComponents = ({ value = 'benefits', title, items, className = '' }) => {
  const { lang } = Language_i18();
  const latest_version = useSelector(state => state.latest_version);

  const getMainDomain = () => {
    const parts = window.location.hostname.split('.');
    return parts.length > 2 ? parts[parts.length - 2] : parts[0];
  };

  const main_domain = !isLocalHost(window.location.hostname)
    ? (Cookies.get("main_domain") || getMainDomain() || "hust")
    : (Cookies.get("main_domain") || "hust");

  // Cấu trúc dữ liệu hỗ trợ đa ngôn ngữ
  // Cấu trúc dữ liệu hỗ trợ đa ngôn ngữ - ĐÃ SỬA LẠI VĂN PHONG TRUNG TÍNH
  const featuresData = {
    hust: [
      {
        // Thay "Free Service" bằng "Optimized Performance" (Hiệu năng tối ưu)
        title: { en: '⚡ Optimized Performance ⚡', vi: '⚡ Hiệu năng Tối ưu ⚡' },
        description: {
          en: 'System runs on GPU servers to speed up data processing tasks.',
          vi: 'Hệ thống chạy trên máy chủ GPU giúp tăng tốc độ xử lý các tác vụ dữ liệu.'
        },
        borderColor: 'border-pink-400',
        titleColor: 'text-purple-600',
      },
      {
        // Thay "Common Technology" bằng "Stable Infrastructure" (Hạ tầng ổn định)
        title: { en: '🏗️ Stable Infrastructure 🏗️', vi: '🏗️ Hạ tầng Ổn định 🏗️' },
        description: {
          en: 'Microservices architecture ensures the system operates smoothly under load.',
          vi: 'Kiến trúc Microservices giúp hệ thống hoạt động ổn định khi có nhiều truy cập.'
        },
        borderColor: 'border-purple-400',
        titleColor: 'text-pink-600',
      },
      {
        // Thay "Fix Weaknesses" bằng "Regular Updates" (Cập nhật thường xuyên)
        title: { en: '🛠️ Regular Updates 🛠️', vi: '🛠️ Cập nhật Thường xuyên 🛠️' },
        description: {
          en: 'The platform is continuously updated to make it easier for you.',
          vi: 'Nền tảng liên tục cập nhật để bạn sử dụng dễ dàng hơn.'
        },
        borderColor: 'border-blue-400',
        titleColor: 'text-blue-600',
      },
    ],
    // ... (Phần tecom giữ nguyên hoặc sửa tương tự nếu cần)
  };

  // ... (Phần render bên dưới giữ nguyên)

  const features = featuresData[main_domain] || featuresData.hust;
  const glassCard = "bg-slate-950/40 bg-hust-glass backdrop-blur-md border border-white/10 hover:border-hust-blue/50 transition-all duration-500 shadow-md hover:shadow-hust-blue/20 rounded-2xl p-4 sm:p-6 hover:-translate-y-1";
  const resolveLocalizedText = (value) => {
    if (!value || typeof value !== 'object') return '';
    return value[lang] || value.en || value.vi || '';
  };
  const benefitsLabel = resolveLocalizedText({
    en: 'Benefits of the Solution',
    vi: 'Lợi ích của giải pháp',
  });

  if (value === 'tech_stack') {
    if (!items || items.length === 0) {
      return null;
    }

    return (
      <div className={className}>
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 sm:mb-4 bg-gradient-to-r from-hust-pink to-hust-blue bg-clip-text text-transparent">
          {title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((item, index) => {
            const Icon = item.icon;

            return (
              <div key={`${item.title}-${index}`} className={glassCard}>
                {Icon ? (
                  <Icon className={item.iconClassName} />
                ) : null}
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2">
                  {item.title}
                </h3>
                <p className="text-slate-200 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="mt-3">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-2 sm:mb-3 bg-gradient-to-r from-hust-pink to-hust-blue bg-clip-text text-transparent">
          ✨ {benefitsLabel} ✨
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className={glassCard}
            >
              <h3 className="text-lg font-bold text-white">
                {resolveLocalizedText(feature.title)}
              </h3>
              <p className="text-slate-200 mt-2 leading-relaxed">
                {resolveLocalizedText(feature.description)}
              </p>
            </div>
          ))}
        </div>
      </div>
      {((latest_version == 2 || latest_version == 3) && main_domain == 'hust') ? (
        <> </>
      ) : (
        <>
          {/* Đăng ký bảo mật */}
          {main_domain == 'nofake' ? (
            <> </>
          ) : (
            <>
              <div style={{ textAlign: 'center' }} className="mt-0">
                <DownloadButtons />
              </div>
            </>)}
        </>
      )}
    </>
  );
};

export default SystemComponents;
